import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';

export const getTimelines = async ({ orgId, dealId }: { orgId: string; dealId: number }) => {
    const response = await axiosInstance.get(API_ENDPOINTS.TIMELINES(orgId, dealId));
    return response.data;
};

export const useGetTimelines = ({ orgId, dealId }: { orgId: string; dealId: number }) => useQuery({
    queryKey: ['timelines', orgId, dealId],
    queryFn: () => getTimelines({ orgId, dealId }),
});
